// @ts-nocheck
import { Box, Tooltip, Typography } from "@mui/material";
import SmallInfo from "../../assets/createEvent/small-info.svg";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import theme from "../../theme";
import { BsExclamationLg } from "react-icons/bs";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";

export default function CustomHelper({
  children,
  message,
  isText,
  index,
  top,
  right,
  style,
}) {
  const { helpStatus } = useSelector((state) => state?.auth);

  if (index && index !== 0) {
    return children;
  }

  return (
    <div
      style={{
        position: "relative",
        ...(style || {}),
      }}
    >
      {/* NOTE: custom hover icon for it to show */}
      {helpStatus && (
        <Tooltip
          title={message}
          placement="top"
          arrow
          sx={{
            padding: "0px !improtant",
            margin: "0px !important",
            height: "auto",
            width: "auto",
          }}
        >
          <img
            style={{
              position: "absolute",
              top: top ? top : isText ? "-0.65rem" : "-0.55rem",
              right: right ? right : isText ? "-0.65rem" : "-0.55rem",
              zIndex: "1",
              cursor: "pointer",
            }}
            src={SmallInfo}
          />
        </Tooltip>
      )}
      {children}
    </div>
  );
}

CustomHelper.propTypes = {
  children: PropTypes.any,
  message: PropTypes.any,
  isText: PropTypes.bool,
  index: PropTypes.number,
  top: PropTypes.string,
  right: PropTypes.string,
  style: PropTypes.object,
};

export const ColorCodeEstimateHelper = () => {
  const arrList = [
    {
      color: theme.palette.green.main,
      colorTitle: "Green",
      text: "Newly added positions after last estimate generation",
    },
    {
      color: getCssVariableHandler({ variableName: "--primary-yellow-hex" }),
      colorTitle: "Yellow",
      text: "Edited positions after last estimate generation",
    },
    {
      color: getCssVariableHandler({ variableName: "--red-shade-1-hex" }),
      colorTitle: "Red",
      text: "Deleted positions after last estimate generation",
    },
    {
      color: "#ffffff",
      colorTitle: "White",
      text: "No changes",
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        gap: "0.5rem",
        alignItems: "flex-start",
        flexDirection: "column",
      }}
    >
      {arrList?.map((item, idx) => (
        <Box
          key={idx}
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            gap: "0.5rem",
          }}
        >
          <Typography component="span" color={item?.color}>
            {item?.colorTitle}:
          </Typography>
          <Typography component="span">{item?.text}</Typography>
        </Box>
      ))}
    </Box>
  );
};

export const WarningHelperContainer = ({
  children,
  status,
  message,
  operation = null,
  disable,
}) => {
  if (disable) return <>{children}</>;
  return (
    <div
      style={{
        position: "relative",
        height: "100%",
        width: "100%",
        isolation: "isolate",
      }}
    >
      {status && (
        <Tooltip
          title={message}
          placement="top"
          arrow
          sx={{
            padding: "0px !important",
            margin: "0px !important",
            height: "auto",
            width: "auto",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "-0.55rem",
              right: "-0.55rem",
              zIndex: "2",
              cursor: "pointer",
              padding: "0.1rem",
              borderRadius: "3rem",
              backgroundColor: "white",
              display: "flex",
            }}
          >
            <BsExclamationLg
              size={"1rem"}
              style={{
                color: getCssVariableHandler({
                  variableName: "--primary-pink-hex",
                }),
              }}
            />
          </div>
        </Tooltip>
      )}

      {operation && (
        <div
          onClick={operation}
          style={{
            position: "absolute",
            inset: 0,
            zIndex: 1,
            cursor: "pointer",
          }}
        />
      )}

      <div style={{ pointerEvents: operation ? "none" : "auto" }}>
        {children}
      </div>
    </div>
  );
};

WarningHelperContainer.propTypes = {
  children: PropTypes.any,
  status: PropTypes.bool,
  message: PropTypes.any,
  operation: PropTypes.func,
  disable: PropTypes.bool,
};